import type {ReactNode} from 'react';
import {useDockStyle} from './callDock';

interface DockedCardProps {
    readonly width: number;
    readonly role?: string;
    readonly testId?: string;
    readonly className?: string;
    readonly children: ReactNode;
}

export const DockedCard = ({width, role, testId, className = 'z-[60]', children}: DockedCardProps) => {
    const style = useDockStyle({width});
    return (
        <div role={role} data-testid={testId} style={{...style, width}} className={`phq-call-enter fixed max-w-[calc(100vw-32px)] ${className}`}>
            {children}
        </div>
    );
};
